// SSR-safe browser-environment helpers.
// On the server (no window/document) these return sensible desktop defaults so
// components can render during SSR instead of crashing on `screen`/`document`.
// Any width-dependent rendering self-corrects on the client after mount.

export const isBrowser = typeof window !== 'undefined'

export const getScreenWidth = () => (typeof screen !== 'undefined' ? screen.width : 1024)

export const getBodyWidth = () =>
  typeof document !== 'undefined' && document.body ? document.body.clientWidth : 1024
